import { EyeClosedIcon, EyeOpenIcon } from '@radix-ui/react-icons';
import { TextField, IconButton, Tooltip } from '@radix-ui/themes';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

function PasswordField(props: TextField.RootProps) {
    const { t } = useTranslation();
    const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);

    return (
        <TextField.Root
            {...props}
            type={isPasswordVisible ? 'text' : 'password'}
            autoComplete='current-password'
        >
            <TextField.Slot side='right' pl='3'>
                <IconButton
                    type='button'
                    variant='ghost'
                    size='3'
                    onClick={() =>
                        setIsPasswordVisible((currentState) => !currentState)
                    }
                >
                    <Tooltip
                        content={t(
                            `tooltips.${
                                isPasswordVisible
                                    ? 'hide_password'
                                    : 'show_password'
                            }`,
                        )}
                    >
                        {isPasswordVisible ? (
                            <EyeClosedIcon />
                        ) : (
                            <EyeOpenIcon />
                        )}
                    </Tooltip>
                </IconButton>
            </TextField.Slot>
        </TextField.Root>
    );
}

export default PasswordField;
